import { Link } from 'react-router'
import React from 'react'
import { Stack } from '@mui/system'
import { issueTags } from '../../components/Autocomplete'
import { HasWarrantLabel, KVLabel } from '../../components/entities/IssueTypeLabels'
import { GridRenderCellParams } from '@mui/x-data-grid/models'
import { EnrichedNewsItem } from './NewsItemsGrid'

const DateGroupItem = (props: GridRenderCellParams<EnrichedNewsItem> & { isSlim?: boolean }) => {
    const { row, isSlim } = props

    return (
        <>
            <div
                style={{
                    fontWeight: 400,
                    display: 'flex',
                    alignItems: isSlim ? undefined : 'center',
                    minHeight: '40px',
                }}
            >
                <Stack
                    direction='row'
                    spacing={2}
                    sx={{
                        alignItems: isSlim ? undefined : 'center',
                        justifyContent: 'space-between',
                        display: 'flex',
                        width: isSlim ? undefined : '200px',
                    }}
                >
                    {!isSlim && (
                        <Link to={`/companies/${row.companyId}`}>
                            <span style={{ marginLeft: 30 }}>{row.symbol}</span>
                        </Link>
                    )}
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: isSlim ? undefined : 'center',
                            justifyContent: 'flex-start',
                            display: 'flex',
                            width: '65px',
                        }}
                    >
                        {row.issueData ? (
                            issueTags({
                                issueType: row.issueData.type,
                                sharesInUnit: row.issueData.sharesInUnit,
                                hasWarrants: !!row.issueData.hasWarrants,
                                unitExtraContent: row.issueData.unitExtraContent,
                                spac: row.issueData.spac,
                                rto: row.issueData.rto,
                            })
                        ) : row.convertibleData ? (
                            <KVLabel />
                        ) : (
                            <HasWarrantLabel />
                        )}
                    </Stack>
                </Stack>
            </div>
        </>
    )
}

export default DateGroupItem
